import { SERVER_BASE_URL } from "./config";
import { CertificateRequestData } from "./model";

export const useApi = () => {
 
  const GetCertificate = async (certificateRequestData: CertificateRequestData): Promise<string> => {
    return await Post<string>("Certificate", certificateRequestData);
  };

  //BASE
  const Get = async <T>(url: string): Promise<T> => {
    return await Fetch<T>(url, "GET", null, false);
  };

  const Post = async <T>(url: string, body: any, isJson: boolean = false): Promise<T> => {
    return await Fetch<T>(url, "POST", body, isJson);
  };

  const Put = async <T>(url: string, body: any): Promise<T> => {
    return await Fetch(url, "PUT", body, false);
  };

  const Delete = async <T>(url: string): Promise<T> => {
    return await Fetch(url, "DELETE", null, false);
  };

  const Fetch = async <T>(url: string, method: string, body: any = null, isJson: boolean = false): Promise<T> => {
    console.info(method + ": " + url);
    try {
      const body2 = body ? (isJson ? body : JSON.stringify(body)) : null;
      const response = await fetch(SERVER_BASE_URL + url, {
        method, // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json",
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: body2,
        redirect: "error", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      });
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.lastIndexOf("application/json") >= 0) {
          const result: T = await response.json();
          return result;
        } else {
          return {} as T;
        }
      } else {
        // if (response.status === 401)
        //     sessionStorage.setItem("sessionGuid", "");
        let text = "Error";
        switch (response.status) {
          case 401:
            text = "Unauthorized";
            // window.location.pathname = "/login";
            break;
          case 403:
            text = "Forbidden";
            break;
        }
        const errorText = `${text}|${await response.text()}`;
        throw new Error(errorText);
      }
    } catch (error: any) {
      console.error(error.message);
      throw error;
    }
  };
  return {
    GetCertificate,
  };
};

